module.exports = __webpack_public_path__ + "img/sheetMake.0024e3ad.png";